import React, { Component } from 'react'
import { Div, Input, DatePicker, CheckerBox, InputDecimal, Select } from "../../core"
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TablePagination from "@material-ui/core/TablePagination"
import TableSortLabel from "@material-ui/core/TableSortLabel"

import moment from 'moment'

import head_service_item from '../datas/head_service_item.json'
import utilityHelper from '../../../helpers/helperUtil'
import tableHelper from '../../../helpers/tableHelper'
import {
    EVENT_CURRENT_SERVICE_SELECTED,
    EVENT_GET_PO_SERVICE_ORIGINAL,
    EVENT_GET_PO_RELEASE_ORDER
} from '../../../configs/EventTypes'
import { Storage } from "../../../configs"

const numeral = require('numeral')

class GRServiceList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            service_checkall: false,
            local_t_PO_DETAIL: {},
            local_t_GR_SERVICE: [],
            local_t_GR_SERVICELINE: [],
            head_serviceItem: head_service_item,

            order: "asc",
            orderBy: "",
            selected: [],
            page: 0,
            rowsPerpage: 25,

            overall_limit: 0,
            ol_currency: "THB",
            expected_value: 0,
            ev_currency: "THB",
            actual_value: 0,
            av_currency: "THB",
            total_received_value: 0.00,
            trv_currency: "THB",
            serviceItemNo: "",
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.handleServiceItemSelected = this.handleServiceItemSelected.bind(this)
        this.setItemModal = this.setItemModal.bind(this)

        this.setHeaderCheckAll = this.setHeaderCheckAll.bind(this)
        this.setReleaseOrderModal = this.setReleaseOrderModal.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)

        window.emitter.addListener("sumTotalReceivedValueEmitter", this.setCurrentTotalReceivedValue.bind(this))
    }

    componentWillReceiveProps(nextProps) {
        let {
            t_GR_SERVICE,
            t_GR_SERVICELINE
        } = this.props

        const { onServiceItemSelected, onSumTotalReceivedValue, getOverAllLimit } = this.props

        if (t_GR_SERVICE != nextProps.t_GR_SERVICE) {

            let setShow = false
            setShow = nextProps.t_GR_SERVICE && nextProps.t_GR_SERVICE.some(f => f.checked == 1)
            let servicecheck = nextProps.t_GR_SERVICE && nextProps.t_GR_SERVICE.find(f => f.checked == 1)

            let isCheckAllRows = this.setHeaderCheckAll(nextProps.t_GR_SERVICE)

            this.setState({
                local_t_GR_SERVICE: [...nextProps.t_GR_SERVICE],
                service_checkall: isCheckAllRows,
                showServiceLine: setShow,                
            })

            if(this.state.serviceItemNo == ''){
                this.setState({
                    serviceItemNo: typeof (servicecheck) !== "undefined" ? servicecheck.service_item_no : ''
                })
            }

            if (onServiceItemSelected && onSumTotalReceivedValue) {
                
                let itemNo = typeof (servicecheck) !== "undefined" ? servicecheck.service_item_no : ''
                if (this.state.serviceItemNo == '') {
                    onServiceItemSelected(itemNo)
                    onSumTotalReceivedValue(itemNo)
                }

                if (typeof (servicecheck) !== "undefined") {
                    this.setState({
                        overall_limit: servicecheck.overall_limit,
                        ol_currency: servicecheck.ol_currency,
                        expected_value: servicecheck.expected_value,
                        ev_currency: servicecheck.ev_currency,
                        actual_value: servicecheck.actual_value,
                        av_currency: servicecheck.av_currency,
                        total_received_value: servicecheck.total_received_value,
                        trv_currency: servicecheck.trv_currency
                    })
                    getOverAllLimit(servicecheck.overall_limit)
                }

            }

        }

        if (t_GR_SERVICELINE != nextProps.t_GR_SERVICELINE) {
            this.setState({
                local_t_GR_SERVICELINE: [...nextProps.t_GR_SERVICELINE]
            })
        }
    }

    addItemModal(type) {
        const { po_no
        } = this.props

        let unitCode = null
        let employeePIS = Storage.getEmployeePIS()
        let user = Storage.getUser()

        if (!employeePIS) {
            unitCode = user.unitCode
        }
        else {
            unitCode = employeePIS.departmentCode
        }

        window.emitter.emit(EVENT_GET_PO_SERVICE_ORIGINAL, {
            po_no: po_no,
            unitCode: unitCode,
            userId: user.userName
        })

        if (type == "service") {
            window.$('#AddServiceItemModal').modal('show');
        }
    }

    handleSelectAllClick(event) {
        let {
            serviceItemNo,
            local_t_GR_SERVICE,
            local_t_GR_SERVICELINE,
            total_received_value
        } = this.state

        const { onServiceItemSelected, onSumTotalReceivedValue, getOverAllLimit } = this.props

        const checked = event.target && event.target.checked ? 1 : 0
        let setShow = false
        let totalreceive = total_received_value

        let objservice = local_t_GR_SERVICE.find(s => s.checked == '1' || s.checked == 1 || s.checked == true )

        local_t_GR_SERVICE.map((item, index) => {
            if (item.i !== '' && !item.sap_final) {
                local_t_GR_SERVICE[index].checked = checked

                if (typeof (objservice) !== "undefined") {
                    local_t_GR_SERVICE[index].requisitioner = objservice.requisitioner
                }

            }
        })

        setShow = local_t_GR_SERVICE && local_t_GR_SERVICE.some(f => f.checked == 1)

        if (setShow) {
            let serviceItem = local_t_GR_SERVICE.find(f => f.checked == 1)
            if (serviceItem) {
                this.setState({
                    serviceItemNo: serviceItem.service_item_no,
                    overall_limit: serviceItem.overall_limit,
                    ol_currency: serviceItem.ol_currency,
                    expected_value: serviceItem.expected_value,
                    ev_currency: serviceItem.ev_currency,
                    actual_value: serviceItem.actual_value,
                    av_currency: serviceItem.av_currency,
                    total_received_value: serviceItem.total_received_value,
                    trv_currency: serviceItem.trv_currency
                })
                if (onServiceItemSelected) {
                    getOverAllLimit(serviceItem.overall_limit)
                    onServiceItemSelected(serviceItem.service_item_no)
                    totalreceive = onSumTotalReceivedValue(serviceItem.service_item_no)
                }
            }

        } else {
            if (onServiceItemSelected) {
                onServiceItemSelected('')
            }
        }

        this.setState({
            showServiceLine: setShow
        })

        let isCheckAllRows = this.setHeaderCheckAll(local_t_GR_SERVICE)
        this.setState({ service_checkall: isCheckAllRows, total_received_value: totalreceive })
    }

    handleChange(event, index) {
        const { local_t_GR_SERVICE } = this.state
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }
                }
            }
        }

        if (valid) {

            let current = local_t_GR_SERVICE[index]
            if (current[name] != value) {
                local_t_GR_SERVICE[index][name] = value
                this.setState({ local_t_GR_SERVICE: local_t_GR_SERVICE })
                //this.props.updateGR_Service(value, index, name)
            }

            if(name === "goods_recipient" || name === 'unloading_point' || name === 'requisitioner'){
                for(let i=0;i<local_t_GR_SERVICE.length;i++){
                    if(
                        index !== i &&
                        (local_t_GR_SERVICE[i][name]==null || local_t_GR_SERVICE[i][name]=="") &&
                        (local_t_GR_SERVICE[i].checked === 1 ||  local_t_GR_SERVICE[i].checked === "1")
                    )
                    local_t_GR_SERVICE[i][name] = value
                }
                this.setState({local_t_GR_SERVICE: local_t_GR_SERVICE})
            }

        } else {
            return
        }
    }

    handleServiceItemSelected(event) {
        const target = event.target;
        let value = target.value;
        const name = target.name;

        const { onServiceItemSelected, onSumTotalReceivedValue, getOverAllLimit } = this.props

        let { local_t_GR_SERVICELINE, local_t_GR_SERVICE } = this.state
        let local_overall_limit = 0

        // let _serviceline = local_t_GR_SERVICELINE.filter((data) => {
        //     return (data.service_item_no && (data.service_item_no + '') === (value + '')) || ((data.running != '' || data.running == 0) && data.checked)
        // })
        let _serviceline = local_t_GR_SERVICELINE.filter((data) => {
            return (data.service_item_no && (data.service_item_no + '') === (value + ''))
        })

        if (_serviceline) {
            this.setState({
                serviceline_render: _serviceline
            })


            let grserviceItem = local_t_GR_SERVICE.find(f => f.service_item_no == value)
            if (grserviceItem) {
                this.setState({
                    overall_limit: grserviceItem.overall_limit,
                    ol_currency: grserviceItem.ol_currency,
                    expected_value: grserviceItem.expected_value,
                    ev_currency: grserviceItem.ev_currency,
                    actual_value: grserviceItem.actual_value,
                    av_currency: grserviceItem.av_currency,
                    total_received_value: grserviceItem.total_received_value,
                    trv_currency: grserviceItem.trv_currency
                })
                local_overall_limit = grserviceItem.overall_limit
            }
        }

       
        let totalreceive = 0
        if (onServiceItemSelected) {
            onServiceItemSelected(value)
            getOverAllLimit(local_overall_limit)
            totalreceive = onSumTotalReceivedValue(value)
        }

        this.setState({
            serviceItemNo: value,
            total_received_value: totalreceive
        })
    }

    handleClick(event, index, choose_item = "") {
        if (!event) return

        let {
            serviceItemNo,
            serviceline_render,
            showServiceLine,
            local_t_GR_SERVICE,
            local_t_GR_SERVICELINE,
            total_received_value
        } = this.state

        const { onServiceItemSelected, onSumTotalReceivedValue, getOverAllLimit } = this.props

        let local_serviceItemNo = serviceItemNo != '' ? serviceItemNo : ''
        let setShow = false
        let checked = event.target.checked ? 1 : 0
        let totalreceive = total_received_value
        let local_overall_limit = 0

        if (choose_item.action === "delete") {
            setShow = true
            this.setState({
                showServiceLine: true,
            })
        } else {

            let objservice = local_t_GR_SERVICE.find(s => s.checked)
            if (typeof (objservice) !== "undefined") {
                local_t_GR_SERVICE[index].requisitioner = objservice.requisitioner
            }

            local_t_GR_SERVICE[index].checked = checked
            this.setState({
                local_t_GR_SERVICE,
            })
        }


        setShow = local_t_GR_SERVICE && local_t_GR_SERVICE.some(f => f.checked == 1)

        let serviceItem = local_t_GR_SERVICE[index]
        if (serviceItem) {
            if (serviceItem.checked == 1) {

                setShow = true
                if (choose_item.action == "copy") {
                    if (serviceItemNo === "") {
                        this.setState({
                            serviceItemNo: choose_item.data.service_item_no,
                            overall_limit: serviceItem.overall_limit,
                            ol_currency: serviceItem.ol_currency,
                            expected_value: serviceItem.expected_value,
                            ev_currency: serviceItem.ev_currency,
                            actual_value: serviceItem.actual_value,
                            av_currency: serviceItem.av_currency,
                            total_received_value: serviceItem.total_received_value,
                            trv_currency: serviceItem.trv_currency
                        })
                        local_overall_limit = serviceItem.overall_limit
                    }
                    else if (Number(serviceItemNo) === Number(choose_item.data.service_item_no)
                        && this.state.overall_limit !== serviceItem.overall_limit) {
                        this.setState({
                            serviceItemNo: choose_item.data.service_item_no,
                            overall_limit: serviceItem.overall_limit,
                            ol_currency: serviceItem.ol_currency,
                            expected_value: serviceItem.expected_value,
                            ev_currency: serviceItem.ev_currency,
                            actual_value: serviceItem.actual_value,
                            av_currency: serviceItem.av_currency,
                            total_received_value: serviceItem.total_received_value,
                            trv_currency: serviceItem.trv_currency
                        })
                        local_overall_limit = serviceItem.overall_limit
                    }

                }
                else {
                    if (serviceItemNo === "") {
                        local_serviceItemNo = serviceItem.service_item_no
                        this.setState({
                            serviceItemNo: serviceItem.service_item_no,
                            overall_limit: serviceItem.overall_limit,
                            ol_currency: serviceItem.ol_currency,
                            expected_value: serviceItem.expected_value,
                            ev_currency: serviceItem.ev_currency,
                            actual_value: serviceItem.actual_value,
                            av_currency: serviceItem.av_currency,
                            total_received_value: serviceItem.total_received_value,
                            trv_currency: serviceItem.trv_currency
                        })
                        local_overall_limit = serviceItem.overall_limit
                    }
                    else if (Number(serviceItemNo) === Number(serviceItem.service_item_no) && this.state.overall_limit !== serviceItem.overall_limit) {
                        local_serviceItemNo = serviceItem.service_item_no
                        this.setState({
                            serviceItemNo: serviceItem.service_item_no,
                            overall_limit: serviceItem.overall_limit,
                            ol_currency: serviceItem.ol_currency,
                            expected_value: serviceItem.expected_value,
                            ev_currency: serviceItem.ev_currency,
                            actual_value: serviceItem.actual_value,
                            av_currency: serviceItem.av_currency,
                            total_received_value: serviceItem.total_received_value,
                            trv_currency: serviceItem.trv_currency
                        })
                        local_overall_limit = serviceItem.overall_limit

                    }
                    else if (Number(serviceItemNo) !== Number(serviceItem.service_item_no)) {
                        let Ischeckservice = local_t_GR_SERVICE.find(f => f.service_item_no == serviceItemNo
                            && f.checked == 1)
                        if (!Ischeckservice) {
                            local_serviceItemNo = serviceItem.service_item_no
                            this.setState({
                                serviceItemNo: serviceItem.service_item_no,
                                overall_limit: serviceItem.overall_limit,
                                ol_currency: serviceItem.ol_currency,
                                expected_value: serviceItem.expected_value,
                                ev_currency: serviceItem.ev_currency,
                                actual_value: serviceItem.actual_value,
                                av_currency: serviceItem.av_currency,
                                total_received_value: serviceItem.total_received_value,
                                trv_currency: serviceItem.trv_currency
                            })
                            local_overall_limit = serviceItem.overall_limit
                        }
                    }

                }

            }
            else {

                if (Number(serviceItemNo) === Number(serviceItem.service_item_no)) {
                    let servicecheck = local_t_GR_SERVICE.find(f => f.checked == 1)
                    if (servicecheck) {
                        setShow = true
                        local_serviceItemNo = servicecheck.service_item_no
                        this.setState({
                            serviceItemNo: servicecheck.service_item_no,
                            overall_limit: servicecheck.overall_limit,
                            ol_currency: servicecheck.ol_currency,
                            expected_value: servicecheck.expected_value,
                            ev_currency: servicecheck.ev_currency,
                            actual_value: servicecheck.actual_value,
                            av_currency: servicecheck.av_currency,
                            total_received_value: servicecheck.total_received_value,
                            trv_currency: servicecheck.trv_currency
                        })
                        local_overall_limit = servicecheck.overall_limit

                    } else {
                        setShow = false
                        local_serviceItemNo = ''
                        this.setState({
                            serviceItemNo: "",
                            overall_limit: 0,
                        })
                        local_overall_limit = 0
                    }

                }
            }

            if (showServiceLine !== setShow) {
                this.setState({
                    showServiceLine: setShow
                })

            }

            if (local_serviceItemNo != serviceItemNo || showServiceLine !== setShow) {
                if (onServiceItemSelected) {
                    onServiceItemSelected(local_serviceItemNo)
                    getOverAllLimit(local_overall_limit)
                    totalreceive = onSumTotalReceivedValue(local_serviceItemNo)
                }
            }

            let isCheckAllRows = this.setHeaderCheckAll(local_t_GR_SERVICE)
            this.setState({ service_checkall: isCheckAllRows, total_received_value: totalreceive })
        }
    }

    setItemModal(type, index = "") {

        const {
            local_t_GR_SERVICE,
            local_t_PO_DETAIL
        } = this.state

        const {
            t_GR_SERVICE,
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
        } = this.props

        let po_no = local_t_PO_DETAIL.po_contract_no;
        let is_contract = utilityHelper.checkIsContract(po_no);

        let viewmode = false

        let service = local_t_GR_SERVICE[index]
        if (service) {
            if (is_contract) {
                viewmode = service.sap_final ? true : false
            }
            else {
                viewmode = (service.i == '' || service.sap_final) ? true : false
            }
        }

        let data = {
            index: index,
            viewmode: viewmode,
            type: type,
            headerModal: "รายละเอียดการรับบริการ"
        }

        window.emitter.emit(EVENT_CURRENT_SERVICE_SELECTED, {
            itemDetail: service,
            setDataItemModal: data,
            service_gr: t_GR_SERVICE,
            is_contract: is_contract
        })
    }
    
    setReleaseOrderModal(type, itemNo = "", contractItemNo = "", po_qty = "", order_unit ="") {
       
        const { po_no
        } = this.props
        
        if (contractItemNo != "" && contractItemNo != null){
            itemNo = contractItemNo
        }

        window.emitter.emit(EVENT_GET_PO_RELEASE_ORDER, {
            po_no: po_no,
            itemNo: itemNo,
            target_qty: po_qty,
            unit: order_unit,
            type: "service"
        })
        window.$('#ReleaseOrderModal').modal('show');
    }


    setHeaderCheckAll(object) {

        let isCheckAllRows = false

        let rowCount = object == null ? 0 : object.length //จำนวนรายการบริการทั้งหมด

        if (rowCount > 0) {
            let rowCheckedCount = object && object.filter(f => f.checked == 1).length
            //ถ้ากด checkall ทุกรายการ
            isCheckAllRows = rowCount == rowCheckedCount
        }
        return isCheckAllRows
    }

    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }

    async setCurrentTotalReceivedValue(data) {

        const { t_total_value,
            t_serviceItemNo
        } = data
        const { serviceItemNo } = this.state

        if (serviceItemNo == t_serviceItemNo) {
            await this.setState({
                total_received_value: t_total_value
            })
        }
    }

    render() {
        const {
            viewMode,
            docTypeService,
            is_contract,
            po_no
        } = this.props

        const {
            local_t_GR_SERVICE,
            service_checkall,
            expected_value,
            ev_currency,
            actual_value,
            av_currency,
            trv_currency,
            showServiceLine,
            overall_limit,
            head_serviceItem,
            order,
            orderBy,
            page,
            rowsPerpage,
            serviceItemNo
        } = this.state

        let { total_received_value } = this.state
       
        return (
            <React.Fragment>
                {local_t_GR_SERVICE.length > 0 && (
                    <div className="rrs-detail pt-1 pb-1 px-5">
                        <div className="sp-table-container">
                            <div className="row rrs-table-hdr-wrap">
                                <div className="col"><h2 className="rrs-table-hdr">รายการรับบริการ</h2></div>
                            </div>
                            <div className="row sp-pagination-control-top">
                                <Div className="col-auto create-button" doctype={docTypeService} tagid="gr.service_header.add" viewMode={viewMode}>
                                    <a href="#" className="sp-bt-addmore" onClick={() => this.addItemModal("service")} data-toggle="modal">
                                        <i className="icon btn-plus" />
                                        <span>เพิ่ม</span>
                                    </a>
                                </Div>
                            </div>
                            <div className="row no-gutters sp-table-content" >
                                <Table aria-labelledby="tableTitle" className="sp-table table rrs-table"  >
                                    <TableHead>
                                        <TableRow className="sp-table-header">
                                            <TableCell padding="checkbox" className="th-table text-center">
                                                <CheckerBox
                                                    checked={service_checkall}
                                                    onChange={(event) => this.handleSelectAllClick(event, local_t_GR_SERVICE, "t_GR_SERVICE", "selected")}
                                                    inputProps={{ "aria-label": "select all item" }}
                                                    color="primary"
                                                    viewMode={viewMode}
                                                />
                                            </TableCell>
                                            {viewMode === false && (
                                                <React.Fragment>
                                                    {is_contract == true && (
                                                        <TableCell className="th-table text-center" >
                                                            Delete
                                                        </TableCell>
                                                    )}
                                                </React.Fragment>)
                                            }
                                            {head_serviceItem.map(row => (
                                                ( row.id === "po" && row.iscontract == is_contract ) ? null : <TableCell
                                                    className="th-table text-center"
                                                    key={row.id}
                                                    align={row.numeric ? "right" : "left"}
                                                    padding={row.disablePadding ? "none" : "default"}
                                                    sortDirection={orderBy === row.id ? order : false}
                                                    style={{ minWidth: row.width }}
                                                >
                                                    {!row.disableSort && (<TableSortLabel
                                                        active={orderBy === row.id}
                                                        direction={order}
                                                        onClick={() => this.handleRequestSort("order", "orderBy", row.id)}
                                                    >
                                                        <div className="th-text">{row.label}</div>
                                                        {orderBy === row.id ? (
                                                            <span
                                                                style={{
                                                                    border: 0,
                                                                    clip: "rect(0 0 0 0)",
                                                                    height: 1,
                                                                    margin: -1,
                                                                    overflow: "hidden",
                                                                    padding: 0,
                                                                    position: "absolute",
                                                                    top: 20,
                                                                    width: 1
                                                                }}
                                                            >
                                                                {order === "desc"
                                                                    ? "sorted descending"
                                                                    : "sorted ascending"}
                                                            </span>
                                                        ) : null}
                                                    </TableSortLabel>)}
                                                    {row.disableSort && (
                                                        <div className="th-text">{row.label}</div>
                                                    )}
                                                </TableCell>
                                            ))}

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tableHelper.stableSort(local_t_GR_SERVICE, tableHelper.getSorting(order, orderBy))
                                            .slice(page * rowsPerpage, page * rowsPerpage + rowsPerpage)
                                            .map((row, index) => {
                                                const isItemSelected = (row.checked == 1 ? true : false);
                                                const labelId = `enhanced-table-checkbox-${index}`;

                                                let index_start = (page * rowsPerpage);

                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        aria-checked={isItemSelected}
                                                        tabIndex={-1}
                                                        key={`row-service-item-${index}`}
                                                        selected={isItemSelected}
                                                    >
                                                        <TableCell padding="checkbox">
                                                            <CheckerBox
                                                                key={`row-service-item-check-${index}-${row.checked}`}
                                                                checked={isItemSelected}
                                                                name="service_item_list.checked"
                                                                inputProps={{ "aria-labelledby": labelId }}
                                                                color="primary"
                                                                onChange={(event) => this.handleClick(event, Number(index_start + index), "selected")}
                                                                //disabled={(row.i === '' || row.sap_final) ? true : false}
                                                                viewMode={viewMode || row.i === '' || row.sap_final || po_no == null}
                                                            />
                                                        </TableCell>
                                                        {viewMode === false && (
                                                            <React.Fragment>
                                                                {is_contract == true && (
                                                                    <TableCell className="action-icon">
                                                                        <button
                                                                            className="btn"
                                                                            onClick={() => { this.props.onHandleDeleteServiceItem("t_GR_SERVICE", row) }}
                                                                            disabled={(row.contract_item_no != null ? false : true)}
                                                                        >
                                                                            <i className="icon btn-trash" />
                                                                        </button>
                                                                    </TableCell>
                                                                )}
                                                            </React.Fragment>)
                                                        }
                                                        <TableCell className="action-icon">
                                                            <a href="#" onClick={() => this.setItemModal("service", Number(index_start + index))} data-toggle="modal" data-target="#itemModal">
                                                                <i className="icon bt-edit" />
                                                            </a>
                                                        </TableCell>
                                                        {is_contract == true && (
                                                            <TableCell className="action-icon">
                                                                <a href="#" onClick={() => this.setReleaseOrderModal("service", row.service_item_no, row.contract_item_no, "", row.order_unit)} data-toggle="modal" >
                                                                    <i className="icon btn-search-blue" />
                                                                </a>
                                                            </TableCell>
                                                        )}
                                                        <TableCell><label className="label-full text-grid">{row.service_item_no}</label></TableCell>
                                                        <TableCell><label className="label-full text-grid">{row.a}</label></TableCell>
                                                        <TableCell><label className="label-full text-grid">{row.i}</label></TableCell>
                                                        <TableCell><label className="label-full text-grid">{row.material}</label></TableCell>
                                                        <TableCell>
                                                            {(Number(row.checked) == 1) && (
                                                                <Input
                                                                    key={`service_${index_start}_${row.service_item_no}_${row.short_text}`}
                                                                    tagid="gr.item.short_text"
                                                                    doctype={docTypeService}
                                                                    name={"short_text"}
                                                                    defaultValue={row.short_text}
                                                                    id="short_text"
                                                                    onBlur={(event) => this.handleChange(event, Number(index_start + index))}
                                                                    viewMode={viewMode}
                                                                    maxlength="40"
                                                                />
                                                            )}
                                                            {(Number(row.checked) !== 1) && (
                                                                <label className="label-full text-grid">{row.short_text}</label>
                                                            )}
                                                        </TableCell>
                                                        <TableCell className="text-center" ><label className="label-full text-grid">{row.order_unit}</label></TableCell>
                                                        <TableCell>
                                                            {(Number(row.checked) == 1) && (
                                                                <DatePicker
                                                                    value={row.delivery_date
                                                                        ? moment(row.delivery_date).format('DD/MM/YYYY')
                                                                        : ""}
                                                                    name="delivery_date"
                                                                    id="delivery_date"
                                                                    onChange={(event) => this.handleChange(event, Number(index_start + index))}
                                                                    onBlur={(event) => this.handleChange(event, Number(index_start + index))}
                                                                    doctype={docTypeService}
                                                                    tagid="gr.item.delivery_date"
                                                                    viewMode={viewMode}
                                                                />)}
                                                            {(Number(row.checked) !== 1) && (
                                                                <label className="label-full text-grid">{row.delivery_date ? moment(row.delivery_date).format('DD/MM/YYYY') : ""}</label>
                                                            )}
                                                        </TableCell>
                                                        <TableCell className="text-right">
                                                            {(Number(row.checked) == 1) && (
                                                                <InputDecimal
                                                                    key={`service_${index_start}_${row.service_item_no}_${row.net_price}`}
                                                                    type="text"
                                                                    id="net_price"
                                                                    name="net_price"
                                                                    pattern="[0-9.,]*"
                                                                    defaultValue={row.net_price ? (numeral(row.net_price).format('0,0.00')) : ""}
                                                                    className="form-control text-right "
                                                                    onBlur={(event) => this.handleChange(event, Number(index_start + index))}
                                                                    inputMode="decimal"
                                                                    floatingPoint={2}
                                                                    step="0,0.00"
                                                                    doctype={docTypeService}
                                                                    tagid="gr.item.net_price"
                                                                    viewMode={viewMode}
                                                                />
                                                            )}
                                                            {(Number(row.checked) !== 1) && (
                                                                <label className="label-full text-grid">{numeral(row.net_price).format('0,0.00')}</label>
                                                            )}
                                                        </TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid">{row.currency}</label></TableCell>
                                                        <TableCell><label className="label-full text-grid">{row.per}</label></TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid">{row.opu}</label></TableCell>
                                                        <TableCell>
                                                            {(Number(row.checked) == 1) && (
                                                                <InputDecimal
                                                                    key={`service_${index_start}_${row.service_item_no}_${row.requisitioner}`}
                                                                    doctype={docTypeService}
                                                                    tagid="gr.item.requisitioner"
                                                                    type="text"
                                                                    name="requisitioner"
                                                                    pattern="[0-9]*"
                                                                    defaultValue={row.requisitioner || ''}
                                                                    className="form-control"
                                                                    id="requisitioner"
                                                                    onBlur={(event) => this.handleChange(event, Number(index_start + index))}
                                                                    inputMode="decimal"
                                                                    maxlength="8"
                                                                    floatingPoint={0}
                                                                    viewMode={viewMode}
                                                                />
                                                            )}
                                                            {(Number(row.checked) !== 1) && (
                                                                <label className="label-full text-grid">{row.requisitioner}</label>
                                                            )}
                                                        </TableCell>

                                                        <TableCell><label className="label-full text-grid">{row.material_group}</label></TableCell>
                                                        <TableCell><label className="label-full text-grid">{row.plant}</label></TableCell>

                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </div>
                        </div>
                    </div>)
                }

                {local_t_GR_SERVICE.length > 0 && (
                    <div className="rrs-detail pt-0 pb-1 px-5">
                        <TablePagination
                            className="pager"
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={local_t_GR_SERVICE.length}
                            rowsPerPage={this.state.rowsPerpage}
                            page={this.state.page}
                            backIconButtonProps={{
                                "aria-label": "previous page"
                            }}
                            nextIconButtonProps={{
                                "aria-label": "next page"
                            }}
                            onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page")}
                            onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page", "rowsPerpage")}
                        />
                    </div>
                )}

                {
                    (local_t_GR_SERVICE.length > 0
                        && showServiceLine
                    )
                    && (<div className="rrs-detail py-1">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="rrs-form">
                                    <div className="row">
                                        <div className="col-md-2 rrs-detail-data">
                                            <label htmlFor="items" id="lbl-gr_service_item" className="rrs-label">Items</label>
                                        </div>
                                        <div className="col-md-9 rrs-detail-data">
                                            <Select
                                                name="items"
                                                value={this.state.serviceItemNo}
                                                onChange={this.handleServiceItemSelected}
                                                doctype={"*"}
                                                tagid="gr.service.item"
                                            // viewMode={viewMode}
                                            >
                                                {local_t_GR_SERVICE && local_t_GR_SERVICE.map((serviceItem, index) => (
                                                    Number(serviceItem.checked) === 1 && (
                                                        <option
                                                            key={index}
                                                            value={serviceItem.service_item_no || ''}>
                                                            {"item " + serviceItem.service_item_no + " - " + serviceItem.short_text}
                                                        </option>
                                                    )
                                                ))}
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)}

                <div className="rrs-detail py-1">
                    {
                        (showServiceLine && overall_limit > 0)
                        && (<div className="row mt-3">
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <div className="row">
                                        <div className="col-4 rrs-detail-data">
                                            <label htmlFor="overall_limit" id="lbl-gr_service_overall_limit" className="rrs-label mt-2">Overall Limit</label>
                                        </div>
                                        <div className="col-5 rrs-detail-data">

                                            <Input
                                                id="overall_limit"
                                                name="overall_limit"
                                                value={(this.state.overall_limit).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}
                                                doctype={"S*"}
                                                tagid="gr.service.overall_limit"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                        <div className="col-3 rrs-detail-data">
                                            <Input
                                                id="ol_currency"
                                                name="ol_currency"
                                                value={this.state.ol_currency || ''}
                                                disabled="disabled"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <div className="row">
                                        <div className="col-4 rrs-detail-data">
                                            <label htmlFor="expected_value" id="lbl-gr_service_expected_value" className="rrs-label mt-2">Expected Value</label>
                                        </div>
                                        <div className="col-5 rrs-detail-data">
                                            <Input
                                                id="expected_value"
                                                name="expected_value"
                                                value={expected_value ? (numeral(expected_value).format('0,0.00')) : "0.00"}
                                                doctype={"S*"}
                                                tagid="gr.service.expected_value"
                                                disabled="disabled"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                        <div className="col-3 rrs-detail-data">
                                            <Input
                                                id="ev_currency"
                                                name="ev_currency"
                                                value={ev_currency || ''}
                                                disabled="disabled"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <div className="row">
                                        <div className="col-4 rrs-detail-data">
                                            <label htmlFor="actual_value" id="lbl-gr_service_actual_value" className="rrs-label mt-2">Actual Value</label>
                                        </div>
                                        <div className="col-5 rrs-detail-data">
                                            <Input
                                                id="actual_value"
                                                name="actual_value"
                                                //doctype={"S*"}
                                                tagid="gr.service.actual_value"
                                                value={actual_value ? (numeral(actual_value).format('0,0.00')) : "0.00"}
                                                disabled="disabled"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                        <div className="col-3 rrs-detail-data">
                                            <Input
                                                id="av_currency"
                                                name="av_currency"
                                                value={av_currency || ''}
                                                disabled="disabled"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    {(local_t_GR_SERVICE.length > 0 && showServiceLine) && (
                        <div className="row mt-3">
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <div className="row">
                                        <div className="col-4 rrs-detail-data">
                                            <label htmlFor="total_received_value" id="lbl-gr.service.total_received_value" className="rrs-label">Total Received Value</label>
                                        </div>
                                        <div className="col-5 rrs-detail-data">
                                            <Input
                                                id="total_received_value"
                                                name="total_received_value"
                                                value={total_received_value ? (numeral(total_received_value).format('0,0.00')) : "0.00"}
                                                doctype={"S*"}
                                                tagid="gr.service.total_received_value"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                        <div className="col-3 rrs-detail-data">
                                            <Input
                                                id="trv_currency"
                                                name="trv_currency"
                                                value={trv_currency || ''}
                                                disabled="disabled"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}

                </div>
            </React.Fragment>
        )
    }
}

export default GRServiceList